export enum Headers {
  GAMIX_APP_ID = 'gamix-app-id',
  CONTENT_TYPE = 'Content-Type',
  AUTHORIZATION = 'Authorization',
}
